import { ConfigService } from '../configuration/config.service';

export function eidAppInitializer(eid: any, configService: ConfigService) {
  return async () => {
    if (!eid) {
      console.warn('EID SDK not available');
      return Promise.resolve();
    }

    const config = configService.getConfig();

    await eid.configure((cfg: any) => {
      cfg
        .logging({
          level: config.production ? 0 : 4
        })
        .openIdConnect({
          clientId: config.authSettings.clientId,
          redirectUri: `${window.location.origin}/eid-callback`,
          enabled: true,
          enableLogs: !config.production
        })
        .sessionManagement({
          enableLogs: !config.production,
          onBeforeLogout: async () => {
            console.log('[EID] Session timeout detected - onBeforeLogout called');
            // Clean up local storage
            localStorage.removeItem('a360-refresh-token');
            localStorage.removeItem('a360-access-token');
            localStorage.removeItem('activeDirectorySettings');

            const authBroadcastChannel = new BroadcastChannel('auth-channel');
            authBroadcastChannel.postMessage('eid-logout-requested');

            try {
              await eid.oidc.signOut({ extraQueryParams: { reason: 'idle' } });
            } catch (error) {
              console.error('[EID] Error during signOut:', error);
            }
          }
        })
        .auditing({
          productCode: 'FTO',
          enabled: false
        });
    });

    return Promise.resolve();
  };
}
